import { pb } from "./pocketbase";
import { financeiroIntegracaoService } from "./financeiroIntegracaoService";
import { getActiveOperator } from "../utils/operatorUtils";

export const productionService = {
  // --- NOVO: ADICIONAR MENSAGEM NO MURAL ---
  async addMuralMessage(orderId, text, type, userName) {
    let record;
    try {
      record = await pb.collection("production_orders").getOne(orderId);
    } catch (e) {
      console.error("Erro ao buscar pedido para addMuralMessage", e);
      throw e;
    }

    const fullData = record.full_data || {};
    if (!Array.isArray(fullData.messages)) {
      fullData.messages = [];
    }

    const model = pb.authStore.model;
    const nameUpper = String(model?.name || "").toUpperCase();
    const userUpper = String(model?.username || "").toUpperCase();
    const isShared = ["OFICINA", "PDV1"].some((term) => nameUpper.includes(term) || userUpper.includes(term));
    const termType = (nameUpper.includes("PDV") || userUpper.includes("PDV")) ? "PDV" : "OFICINA";
    const activeOp = getActiveOperator(termType);
    const finalAuthor = activeOp && isShared ? `${termType} · ${activeOp.nome}` : (userName || "Sistema");

    const newMsg = {
      id: "msg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
      text: text,
      type: type || "user",
      author: finalAuthor,
      timestamp: new Date().toISOString(),
    };

    fullData.messages.push(newMsg);

    const updatedRecord = await pb.collection("production_orders").update(orderId, {
      full_data: fullData,
    });
    return updatedRecord;
  },

  // --- 1. ATUALIZAR STATUS (MOVER CARD NO KANBAN) ---
  async updateStatus(orderId, newStatus, oldStatus, userName) {
    // Busca o registro para deep-patch
    let record;
    try {
      record = await pb.collection("production_orders").getOne(orderId);
    } catch (e) {
      console.error("Erro ao buscar pedido para updateStatus", e);
      return;
    }

    const fullData = record.full_data || {};
    fullData.status = newStatus; // Sync JSON

    // Log status change in mural
    if (!Array.isArray(fullData.messages)) {
      fullData.messages = [];
    }
    
    const model = pb.authStore.model;
    const nameUpper = String(model?.name || "").toUpperCase();
    const userUpper = String(model?.username || "").toUpperCase();
    const isShared = ["OFICINA", "PDV1"].some((term) => nameUpper.includes(term) || userUpper.includes(term));
    const termType = (nameUpper.includes("PDV") || userUpper.includes("PDV")) ? "PDV" : "OFICINA";
    const activeOp = getActiveOperator(termType);
    const finalAuthor = activeOp && isShared ? `${termType} · ${activeOp.nome}` : (userName || "Sistema");

    const displayOld = oldStatus || record.status || "Status Inicial";
    const newMsg = {
      id: "msg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
      text: `Etapa alterada de "${displayOld}" para "${newStatus}" por ${finalAuthor}`,
      type: "system",
      author: finalAuthor,
      timestamp: new Date().toISOString(),
    };
    fullData.messages.push(newMsg);

    await pb.collection("production_orders").update(orderId, {
      status: newStatus,
      full_data: fullData, // Envia o JSON atualizado
    });
  },

  async togglePE(orderId, currentIsIntercepted, userName) {
    const isNowIntercepted = !currentIsIntercepted;

    // 1. Busca o registro completo para ter o "full_data" e o "stockItemId"
    let record;
    try {
      record = await pb.collection("production_orders").getOne(orderId);
    } catch (e) {
      console.error("Erro ao buscar pedido para togglePE", e);
      return;
    }

    const stockItemId = record.stockItemId;
    const fullData = record.full_data || {}; // Clona ou incia vazio

    // 2. Prepara as mudanças (Deep Patch)
    // Atualizamos tanto no JSON (full_data) quanto nas colunas (se existirem)
    fullData.isInterceptedPE = isNowIntercepted;

    // Log PE change in mural
    if (!Array.isArray(fullData.messages)) {
      fullData.messages = [];
    }
    const actionText = isNowIntercepted ? "URGÊNCIA PRONTA ENTREGA ATIVADA (Item Interceptado)" : "Urgência Pronta Entrega Removida";
    const newMsg = {
      id: "msg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
      text: `${actionText} por ${userName || "Sistema"}`,
      type: "system",
      author: userName || "Sistema",
      timestamp: new Date().toISOString(),
    };
    fullData.messages.push(newMsg);

    // Objeto de update que será enviado ao PB
    const updates = {
      isInterceptedPE: isNowIntercepted, // Coluna (se existir)
      full_data: fullData,               // JSON (Garantido)
    };

    if (!isNowIntercepted) {
      // --- LIBERAR: VOLTAR PARA ESTOQUE ---
      updates.fromStock = true;
      fullData.fromStock = true;

      updates.linkedOrderNumber = "";
      updates.linkedCustomer = "";
      // Limpa dentro do JSON também se estiverem lá
      fullData.linkedOrderNumber = "";
      fullData.linkedCustomer = "";

      // SINCRONIA ESTOQUE FÍSICO
      // Se veio de um item físico, marcamos ele como VENDIDO/CONSUMIDO
      if (stockItemId) {
        try {
          await pb.collection("inventory_items").update(stockItemId, {
            status: "sold",
            soldBy: "sistema_interception",
            reason: "Consumido por Pedido (Conversão PE -> Estoque)"
          });
        } catch (err) { console.error("Erro sync inventory release", err); }
      }

    } else {
      // --- INTERCEPTAR: TORNAR URGENTE ---
      updates.fromStock = false;
      fullData.fromStock = false;

      updates.status = "SOLICITACAO";
      fullData.status = "SOLICITACAO"; // Sync status no JSON tb

      // SINCRONIA ESTOQUE FÍSICO
      // Marca o item físico como INTERCEPTADO
      if (stockItemId) {
        try {
          await pb.collection("inventory_items").update(stockItemId, {
            status: "pe_interceptado"
          });
        } catch (err) { console.error("Erro sync inventory intercept", err); }
      }
    }

    // 3. Envia o update com o JSON atualizado
    await pb.collection("production_orders").update(orderId, updates);
  },

  // --- 3. TOGGLE DE TRÂNSITO (SETINHAS SOBE/DESCE) ---
  async toggleTransit(orderId, transitStatus, userName) {
    // Deep Patch para Trânsito
    let record;
    try {
      record = await pb.collection("production_orders").getOne(orderId);
    } catch (e) { console.error("Erro toggleTransit", e); return; }

    const fullData = record.full_data || {};
    const safeStatus = transitStatus || "";

    fullData.transit_status = safeStatus;

    // Log transit status change in mural
    if (!Array.isArray(fullData.messages)) {
      fullData.messages = [];
    }
    const transitText = safeStatus === "subindo" ? "SUBINDO (Escritório)" : safeStatus === "descendo" ? "DESCENDO (Fábrica)" : "NENHUM (Retirado de Trânsito)";
    const newMsg = {
      id: "msg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
      text: `Trânsito atualizado para "${transitText}" por ${userName || "Sistema"}`,
      type: "system",
      author: userName || "Sistema",
      timestamp: new Date().toISOString(),
    };
    fullData.messages.push(newMsg);

    await pb.collection("production_orders").update(orderId, {
      transit_status: safeStatus,
      full_data: fullData,
    });
  },

  // --- 4. ATUALIZAR ESPECIFICAÇÕES (MODAL EDITAR) ---
  async updateSpecs(orderId, specs, exception, sku, userName) {
    // Busca o registro para atualizar o JSON 'full_data' também
    const record = await pb.collection("production_orders").getOne(orderId);

    // Clona e atualiza 'full_data'
    const fullData = record.full_data || {};

    // Comparar especificações antigas e novas para documentar a alteração
    const changes = [];
    const oldSpecs = record.specs || {};
    
    if (sku && sku !== record.sku) {
      changes.push(`SKU alterado de "${record.sku}" para "${sku}"`);
    }
    
    if (exception !== undefined && exception !== record.exception) {
      changes.push(`Aviso Vital alterado de "${record.exception || "nenhum"}" para "${exception || "nenhum"}"`);
    }

    const keysToCheck = ["size", "stoneColor", "stoneBatch", "finishing", "engraving", "stoneType"];
    keysToCheck.forEach(key => {
      const oldVal = oldSpecs[key] || "";
      const newVal = specs[key] || "";
      if (oldVal !== newVal) {
        const keyLabels = {
          size: "Aro/Tamanho",
          stoneColor: "Cor da Pedra",
          stoneBatch: "Lote da Pedra",
          finishing: "Acabamento",
          engraving: "Gravação",
          stoneType: "Tipo da Pedra"
        };
        const label = keyLabels[key] || key;
        changes.push(`${label} alterado de "${oldVal || "vazio"}" para "${newVal || "vazio"}"`);
      }
    });

    fullData.specs = specs;
    fullData.status = "PEDIDO_MODIFICADO"; // (FIX: Restaura comportamento de sinalizar modificação)

    if (sku) fullData.sku = sku;

    // Log specs edit in mural
    if (!Array.isArray(fullData.messages)) {
      fullData.messages = [];
    }
    const changeDescription = changes.length > 0 ? changes.join(", ") : "Nenhuma alteração de dados identificada";
    const newMsg = {
      id: "msg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
      text: `Especificações editadas por ${userName || "Sistema"}: ${changeDescription}`,
      type: "system",
      author: userName || "Sistema",
      timestamp: new Date().toISOString(),
    };
    fullData.messages.push(newMsg);

    const updates = {
      specs: specs,
      status: "PEDIDO_MODIFICADO", // (FIX: Marca na raiz tambem)
      full_data: fullData, // Sincronizacao
    };

    if (exception !== undefined && exception !== null) {
      updates.exception = exception; // Coluna Flat
    }

    if (sku) {
      updates.sku = sku; // Coluna Flat
    }

    await pb.collection("production_orders").update(orderId, updates);
  },

  // --- 5. ATUALIZAR CAMPO GENÉRICO (FLEXIBILIDADE) ---
  async updateOrderField(orderId, field, value) {
    // Atenção: Só funciona para campos Flat (Raiz)
    await pb.collection("production_orders").update(orderId, {
      [field]: value
    });

    if (field === "status" && (value === "CANCELADO" || value === "GOLPE")) {
      try {
        await financeiroIntegracaoService.triggerCancellation("production_orders", orderId, pb.authStore.model);
      } catch (errFin) {
        console.warn("Erro ao cancelar pendência financeira do Pedido de Fábrica:", errFin);
      }
    }
  },

  // --- 6. DELETAR PEDIDO ---
  async deleteOrder(orderId) {
    try {
      await financeiroIntegracaoService.triggerCancellation("production_orders", orderId, pb.authStore.model);
    } catch (errFin) {
      console.warn("Erro ao disparar estorno/cancelamento para pedido excluído:", errFin);
    }
    await pb.collection("production_orders").delete(orderId);
  },

  // --- 7. MARCAR LOTE COMO IMPRESSO ---
  async markBatchAsPrinted(orderIds, userName) {
    const promises = orderIds.map(async (id) => {
      let record;
      try {
        record = await pb.collection("production_orders").getOne(id);
      } catch (e) {
        console.error("Erro ao buscar pedido para markBatchAsPrinted", e);
        return;
      }

      const fullData = record.full_data || {};
      if (!Array.isArray(fullData.messages)) {
        fullData.messages = [];
      }

      const newMsg = {
        id: "msg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
        text: `Etiqueta impressa por ${userName || "Sistema"}`,
        type: "system",
        author: userName || "Sistema",
        timestamp: new Date().toISOString(),
      };
      fullData.messages.push(newMsg);

      await pb.collection("production_orders").update(id, {
        printed: true,
        full_data: fullData,
      });
    });
    await Promise.all(promises);
  },
};
